// extracted by mini-css-extract-plugin
export default {"closed-menu":"closed-menu--4jmhP","closedMenu":"closed-menu--4jmhP","closed-menu--hidden":"closed-menu--hidden--ps9UY","closedMenuHidden":"closed-menu--hidden--ps9UY"};